import { getApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  getIframe,
  setAddChangeEventListener,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  stringToHTML,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { amtFormatter } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const PaymentDetails = {
  search: {
    trDiv: '00',
    from: '',
    to: '',
  },

  trDivList: [],
  trDtlDivList: [],
  listData: [],

  initialFrom: '',
  initialTo: '',

  render: async () => {
    const date = new Date();

    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    PaymentDetails.initialFrom = `${year}-${month}-01`;
    PaymentDetails.initialTo = `${year}-${month}-${day}`;

    PaymentDetails.search.from = PaymentDetails.initialFrom;
    PaymentDetails.search.to = PaymentDetails.initialTo;

    return `
       <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
        <div class="c_title1">결제 내역조회</div>
        <div class="form-group m_b_20">
            <div class="c_bod1 c_box skin1_bod" id="payment_status">
                <div class="c_label4_3" id="payment_detail_keyword_label">전체</div>
                <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
            </div>
        </div>
        <div class="form-group m_b_20">
            <div class="c_bod1 c_box skin1_bod" id="date_status">
                <input class="skin1_bod c_label6_3" type="date" id="payment_search_from" value="${PaymentDetails.initialFrom}"/>
                <input class="skin1_bod c_label6_3" type="date" id="payment_search_to" value="${PaymentDetails.initialTo}"/>
            </div>
        </div>
        <div class="p_lr_10">
            <table class="c_table1" id="payment_detail_list_table" />
        </div>
    `;
  },
  afterRender: async () => {
    let preFromDate;
    let preToDate;

    const keywordModalLayer = `
    <div class="modal c_btm1" id="payment_status_content">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">구분</h5>
                    <button type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="payment_detail_keyword_list" />
            </div>
        </div>
    </div>
    `;

    // SetAlertModal
    setAlertModal();

    // initialize
    try {
      const msg = '데이터 로드 중입니다.\n잠시 후 시도해 보세요 (1001)';
      const trDiv = await getApv('common/code?grpCode=TR_DIV');
      if (trDiv == null) throw msg;

      PaymentDetails.trDivList = [
        { codeId: '00', codeName: '전체' },
        ...trDiv.filter((item) => item.codeId % 10 < 1),
      ];

      const trDtlDiv = await getApv('common/code?grpCode=TR_DTL_DIV');
      if (trDtlDiv == null) throw msg;

      PaymentDetails.trDtlDivList = trDtlDiv;
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e);
      console.error(e.resultMessage || e);
      return;
    }

    // Functions
    const switchToRequest = async (params) => {
      //배열 초기화
      PaymentDetails.listData = [];
      try {
        const div = PaymentDetails.search.trDiv;

        const getListData = async (url) => {
          const res = await getApv(`${url}`);
          PaymentDetails.listData = PaymentDetails.listData.concat(res.apprInf);
        };

        if (div === '00') {
          await getListData(`card/paymentList?${params}`);
          await getListData(`account/paymentList?${params}`);
          await getListData(`charging/paymentList?${params}`);
        } else {
          if ('10' == div) {
            await getListData(`card/paymentList?${params}`);
          } else if ('20' == div) {
            await getListData(`account/paymentList?${params}`);
          } else if ('30' == div) {
            await getListData(`charging/paymentList?${params}`);
          }
        }
      } catch (e) {
        showAlertModal('오류', e.resultMessage || e);
        console.error(e.resultMessage || e);
        PaymentDetails.listData = [];
      }
    };

    //View Draw Functions
    const searchPaymentDetails = async () => {
      await switchToRequest(
        `fromTrDt=${PaymentDetails.search.from}&toTrDt=${PaymentDetails.search.to}`
      );
      // 리스트 정렬
      PaymentDetails.listData.sort((a, b) => {
        if (a.trTm == b.trTm) return 0;
        return a.trTm > b.trTm ? -1 : 1;
      });

      PaymentDetails.listData.sort((a, b) => {
        if (a.trDt == b.trDt) return 0;
        return a.trDt > b.trDt ? -1 : 1;
      });

      let listHtml = '';

      for (const item of PaymentDetails.listData) {
        let trDtlDivLabel = '';
        for (const trDtlDiv of PaymentDetails.trDtlDivList) {
          if (trDtlDiv.codeId === item.trDiv) {
            trDtlDivLabel = trDtlDiv.codeName;
            break;
          }
        }

        listHtml += `<tr id="${item.trUniqno}" style="cursor: pointer">
                    <th class="p_b_20">
                        <div class="c_label4_1">${item.merBizName}</div>
                        <div class="c_label5_2">${item.trDt}</div>
                    </th>
                    <td class="p_b_20">
                        <div class="c_label4">${amtFormatter(
                          item.trAmt
                        )}원</div>
                        <div class="c_label5_2">${trDtlDivLabel}</div>
                    </td>
                </tr>`;
      }
      setIframeInnerHtml('payment_detail_list_table', listHtml);

      for (const item of PaymentDetails.listData) {
        setAddEventListener(item.trUniqno, () =>
          pushRouter(
            {
              payment: item,
              trDtlDivList: PaymentDetails.trDtlDivList,
            },
            null,
            routes.paymentDetails2.hashPath
          )
        );
      }
    };

    const onClickKeyword = (item) => {
      getIframe().getElementById('payment_detail_keyword_label').innerText =
        item.innerText;
      PaymentDetails.search.trDiv = item.getAttribute('value');
      getIframe()
        .querySelectorAll('#payment_detail_keyword_list > div')
        .forEach((element) => {
          element.className =
            element.id === PaymentDetails.search.trDiv
              ? 'item c_label6'
              : 'item c_label6_1';
        });
      searchPaymentDetails();

      closeBottomSheet('payment_status');
    };

    const drawKeywordBottomSheet = () => {
      stringToHTML(keywordModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );

      let searchBottomSheetHtml = '';
      for (const item of PaymentDetails.trDivList) {
        let className = 'item c_label6_1';
        if (PaymentDetails.search.trDiv === item.codeId) {
          getIframe().getElementById('payment_detail_keyword_label').innerText =
            item.codeName;
          PaymentDetails.search.trDiv = item.codeId;
          className = 'item c_label6';
        }
        searchBottomSheetHtml += `<div class="${className}" value="${item.codeId}" id="${item.codeId}">${item.codeName}</div>`;
      }

      setIframeInnerHtml('payment_detail_keyword_list', searchBottomSheetHtml);
      setBottomSheet('payment_status');
    };

    //View Draw
    drawKeywordBottomSheet();
    // SetEvents
    setAddEventListener('connect_pay_back_button', () => history.back());
    setAddEventListener('payment_search_from', (e) => {
      preFromDate = e.target.value;
    });
    setAddEventListener('payment_search_to', (e) => {
      preToDate = e.target.value;
    });
    setAddChangeEventListener('payment_search_from', async (e) => {
      const fromDate = e.target.value;
      const toDate = getIframe().getElementById('payment_search_to').value;
      if (fromDate > toDate || fromDate > PaymentDetails.initialTo) {
        fromDate > PaymentDetails.initialTo
          ? showAlertModal(
              '확인',
              '오늘일자 이후는 선택할 수 없습니다.',
              () => {}
            )
          : showAlertModal(
              '확인',
              '종료일자 이후는 선택할 수 없습니다.',
              () => {}
            );
        getIframe().getElementById('payment_search_from').value = preFromDate;
        return;
      }
      PaymentDetails.search.from = fromDate;
      await searchPaymentDetails();
    });
    setAddChangeEventListener('payment_search_to', async (e) => {
      const fromDate = getIframe().getElementById('payment_search_from').value;
      const toDate = e.target.value;
      if (fromDate > toDate) {
        showAlertModal('확인', '시작일자 이전은 선택할 수 없습니다.', () => {});
        getIframe().getElementById('payment_search_to').value = preToDate;
        return;
      }
      PaymentDetails.search.to = toDate;
      await searchPaymentDetails();
    });
    getIframe()
      .querySelectorAll('#payment_detail_keyword_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          onClickKeyword(element);
        });
      });
    await searchPaymentDetails();
  },
};
export default PaymentDetails;
